import { ErrorRounded } from "@mui/icons-material";
import { useRouteError } from "react-router-dom";

function ErrorBoundary() {
  const error = useRouteError() as any;

  return (
    <div className="flex flex-col gap-4 w-screen h-screen justify-center items-center">
      <ErrorRounded style={{ fontSize: 64 }} />
      <div className="text-3xl font-bold ">Something went wrong!</div>
      {error?.message && (
        <div className="text-2xl font-semibold ">{error.message}</div>
      )}
    </div>
  );
}

export default ErrorBoundary;
